import type { ContributorDto } from '@/types/dtos/contributors/response/contributor.dto';

/**
 * Drives profile-review affordance styling.
 * - **default:** no submitted version yet → neutral (use `IconButton` `color="default"`, not `info`)
 * - **warning** / **success:** map directly to MUI `IconButton` `color`
 */
export type ProfileReviewIconColor = 'default' | 'warning' | 'success';

/**
 * Version-based review status: compares the contributor-provided profile's
 * `submittedVersion` with the event profile's `reviewedSubmittedVersion`.
 *
 * - **default:** no submission yet → neutral icon
 * - **warning:** submitted version is newer than reviewed version → crew should review
 * - **success:** crew has reviewed the current (or later) submitted version
 */
export function getContributorProfileReviewIconColor(contributor: ContributorDto): ProfileReviewIconColor {
  const submittedVersion = contributor.userContributor?.providedProfile?.submittedVersion;
  const eventProfile = contributor.profiles?.[0];
  const reviewedVersion = eventProfile?.reviewedSubmittedVersion;

  if (submittedVersion == null) {
    return 'default';
  }

  if (reviewedVersion == null) {
    return 'warning';
  }

  return reviewedVersion >= submittedVersion ? 'success' : 'warning';
}

/** @deprecated Prefer `getContributorProfileReviewIconColor(contributor) === 'warning'` if you need a boolean. */
export function isSpeakerProfileReviewPending(contributor: ContributorDto): boolean {
  return getContributorProfileReviewIconColor(contributor) === 'warning';
}
